import {ActivityModel} from './../app/content/pages/models/planing/activity.model';
import {PolylineModel} from '../app/content/pages/models/planing/polyline.model';
import {isNullOrUndefined} from './util';
import {SolucaoRoteirizacaoRomaneioModel} from '../app/content/pages/models/romaneio/solucao-roteirizacao-romaneio';
import {EntregaSequenciaModel} from '../app/content/pages/models';
import {InfoEntregasRotaModel} from '../app/content/pages/models/info-entregas-rota.model';

export const filterByNameActivity = (nameActivity: string) => ({activity}: ActivityModel) => activity === nameActivity;

export const findOperationsByNumeroPedido = (numeroPedido) => ({operations}) => operations.includes(String(numeroPedido));

export const getActivityAgrupado = (vehicleRoutes) => {

  const {activities} = vehicleRoutes[0].routes[0];
  return activities.reduce((acc, {activity}) => {
    acc[activity] = acc[activity] || [];
    acc[activity].push(...activities.filter(filterByNameActivity(activity)));
    return acc;
  }, {DELIVERY: [], DRIVING: [], LOADING: []});
};


export const filtraEntregaPorIdClienteAndIdEndEntrega =
  (key: string, propToKey: string) =>
    (propToKey2: string) =>
      ({[propToKey]: idCli, [propToKey2]: idEndEntrega}: any) =>
        (`${idCli}-${idEndEntrega || 0}` !== key);


export const getAllNumPedPreCarga = (preCarga) => {
  const numpeds = preCarga
    .flatMap((carga) => carga.listaEntregas)
    .flatMap((entrega) => entrega.pedidos)
    .map((pedido) => pedido.numeroPedido);
  return numpeds;
};

export const getAllIdsFiliaisEntregas = (entregas) => {
  const idsFiliaisSet = new Set<string>(
    entregas
      .flatMap((entrega) => entrega.pedidos)
      .map((pedido) => pedido.filial)
  );
  const idsFiliais = Array.from(idsFiliaisSet);
  return idsFiliais;
};

export const convertPolylineModelToPolylineCoordinateModel = (poly: PolylineModel[]) => {
  const convertPolyline = [];
  poly.filter(pp => pp.coordinates).forEach((p) => convertPolyline.push(p.coordinates));
  return convertPolyline;
};


export const getAllPedPreCarga = (preCarga) => {
  const peds = preCarga
    .flatMap((carga) => carga.listaMarkers)
    .flatMap((marker) => marker.pedidos);
  return peds;
};


export const getAllPedEntregasPreCarga = (entregas) => {
  return entregas
    .flatMap((entrega) => entrega.pedidos);
};

export const somaValorTotalPedidosPreCarga = (preCarga) => {
  const pedidos = preCarga.listaMarkers.flatMap((entrega) => entrega.pedidos);
  return pedidos.reduce((acumulador, pedido) => acumulador + pedido.valorTotal, 0);
};

export const obterPropPedidosMarkerPreCarga = (preCarga: any, campo: string) => {
  const resultado = preCarga.listaMarkers
    .flatMap((marker) => marker.pedidos)
    .flatMap((pedido) => {
      const valor = pedido[campo];
      return valor !== null ? [valor] : [];
    });
  return resultado;
};

export const obterPropMarkerPreCarga = (preCarga: any, campo: string) => {
  const resultado = preCarga.listaMarkers
    .flatMap((marker) => {
      const valor = marker[campo];
      return valor !== null ? [valor] : [];
    });
  return resultado;
};


export const obterInfoEntregasSolucaoRota = (solucao: SolucaoRoteirizacaoRomaneioModel): InfoEntregasRotaModel[] => {

  const idEntregaNull = (ie) => ie === null ? '0' : ie;

  try {

    const activities = solucao.soluction.vehicleRoutes['0'].routes['0'].activities;
    let distanciaCD = 0;
    const retorno = activities.filter((activity) => activity.activity === 'DRIVING').map((activity, index) => {
      const distancia = activity.distance;
      const ponto = activity.arrivalSite.split('_');
      const pontoPartida = activity.departureSite;
      distanciaCD = distanciaCD + (distancia / 1000);
      const entrega = solucao.entregas.find((e) => e.idCliente === ponto[0] && idEntregaNull(e.idEndEntrega) === ponto[1]);
      const peso = isNullOrUndefined(entrega) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.peso, 0);
      const volume = isNullOrUndefined(entrega) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.volume, 0);
      const valor = isNullOrUndefined(entrega) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.valor, 0);
      const idsPedidos = isNullOrUndefined(entrega) ? [] : entrega.listaPedidos.map((pedido) => pedido.id);
      return {
        distancia,
        cliente: ponto[0],
        idEndEntrega: ponto[1],
        pontoPartida,
        dataHoraInicio: activity.startDateTime,
        dataHoraFim: activity.endDateTime,
        duracao: activity.nominalDuration,
        tempoEspera: activity.waitTimeToStart,
        distanciaCD,
        peso,
        volume,
        valor,
        idsPedidos
      };
    });

    return retorno.filter((info) => !['CD', 'PS', 'PR'].includes(info.cliente.split('_')[0]));
  } catch (error) {
    console.log('Erro ao obter informações sobre as entregas', error);
  }
};
export const obterInfoEntregas = (entregas: EntregaSequenciaModel[]): InfoEntregasRotaModel[] => {

  try {

     let distanciaCD = 0;
     const retorno = entregas.map((entrega) => {

       const distancia = entrega.distancia;
       distanciaCD = distanciaCD + (distancia / 1000);

       const peso = isNullOrUndefined(entrega.listaPedidos) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.peso, 0);
       const volume = isNullOrUndefined(entrega.listaPedidos) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.volume, 0);
       const valor = isNullOrUndefined(entrega.listaPedidos) ? 0 : entrega.listaPedidos.reduce((acc, pedido) => acc + pedido.valor, 0);
       const idsPedidos = isNullOrUndefined(entrega) ? [] : entrega.listaPedidos.map((pedido) => pedido.id);

       return {
         distancia,
         cliente: entrega.idCliente,
         idEndEntrega: entrega.idEndEntrega,
         dataHoraInicio: entrega.dataHoraInicio,
         dataHoraFim: entrega.dataHoraFim,
         duracao: entrega.duracao,
         tempoEspera: entrega.tempoEspera,
         distanciaCD,
         peso,
         volume,
         valor,
         idsPedidos
       };

     });
     return retorno.filter((info) => !['CD', 'PS', 'PR'].includes(info.cliente.split('_')[0]));
  } catch (error) {
    console.log('Erro ao obter informações sobre as entregas', error);
  }
};


